"use client";

// Re-export from canonical hooks location for backwards compatibility
// New code should import directly from @/hooks/use-toast
export { toast, useToast } from "@/hooks/use-toast";
